export const PRE_LEASE_LIVE_STATUS_LIVE = 'PRE_LEASE_LIVE_STATUS_LIVE';
export const PRE_LEASE_LIVE_STATUS_CLOSE_DUE_DATE = 'PRE_LEASE_LIVE_STATUS_CLOSE_DUE_DATE';
export const PRE_LEASE_LIVE_STATUS_PAST_DATE = 'PRE_LEASE_LIVE_STATUS_PAST_DATE';
export const PRE_LEASE_LIVE_STATUS_END = 'PRE_LEASE_LIVE_STATUS_END';

export const PRE_LEASE_LIVE_STATUS_LIST = [
  PRE_LEASE_LIVE_STATUS_LIVE,
  PRE_LEASE_LIVE_STATUS_CLOSE_DUE_DATE,
  PRE_LEASE_LIVE_STATUS_PAST_DATE,
  PRE_LEASE_LIVE_STATUS_END,
];
